export const productWidgetComponentId = 'abcd87fe-c51f-4538-848d-2902a2f50d2d';
export const harmonySearchWidgetId = 'ccd9d1bd-c936-4f6a-8db2-b9a68c4cadd1';
